// Typelizer digest 91d5d875fd91b93090c1e078c90a03d9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/workspace */
  show: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/workspace', params, options),
    method: 'get',
  }),
}
